import { FC, ReactNode } from "react";
import { Mesh } from "three";
import { useWater } from "./Environmental/WaterUtils";
import { applyContextPresets } from "./FeatureUtils";
import { useSpriteAnimate } from "./Animation/SpriteUtils";
import { useTrigger } from "./Interaction/TriggerUtils";
import { ModelContextPresets } from "./Model/ContextPresets";
import { EnvironmentalContextPresets } from "./Environmental/ContextPresets";
import { useCameraFollow } from "./Interaction/CameraUtils";

export type MeshFeatureContextHook = (
  mesh: Mesh,
  userData: Record<string, any> | undefined
) => ReactNode | void;

export const COLLISION_REPLACING_CONTEXTS: Record<string, boolean> = {
  Trigger: true,
};

export const hasCollisionReplacingContext = (contexts: string[] = []) =>
  contexts.some((context) => COLLISION_REPLACING_CONTEXTS[context]);

export const MESH_FEATURE_CONTEXT_MAP: Record<string, MeshFeatureContextHook> =
  {
    Water: useWater,
    SpriteAnimate: useSpriteAnimate,
    Trigger: useTrigger,
    CameraFollow: useCameraFollow,
  };

export type MeshFeatureContextProps = {
  mesh: Mesh;
  context: string;
  userData: Record<string, any> | undefined;
};

export const MeshFeatureContext: FC<MeshFeatureContextProps> = ({
  mesh,
  context,
  userData = {},
}) => {
  const hook = MESH_FEATURE_CONTEXT_MAP[context];

  applyContextPresets(mesh, userData, EnvironmentalContextPresets);
  applyContextPresets(mesh, userData, ModelContextPresets);

  if (hook) {
    return hook(mesh, userData) ?? undefined;
  }

  return undefined;
};
